import * as React from "react";
import Container from "./styled";
import { IoMailOutline, IoLocationOutline } from "react-icons/io5";
import { Fade } from "react-awesome-reveal";

export default function DatosFormaParte() {
  return (
    <Container>
      <Fade
        delay={100}
        duration={700}
        triggerOnce={true}
        className="maxWidthContainer"
      >
        {/* Title */}
        <h2>Datos de contacto</h2>
        {/* Adress Data */}
        <div className="dataContainer">
          <p>
            <span>
              <IoLocationOutline />
            </span>
            Ciudad Autónoma de Buenos Aires
          </p>
          <p id="email">
            <span>
              <IoMailOutline />
            </span>
            <strong>Email:</strong>
            <a href="mailto:rrhh@gyssrl.com.ar">rrhh@gyssrl.com.ar</a>
          </p>
        </div>
      </Fade>
    </Container>
  );
}
